import { PlatformNavigation } from "@datassential/platform-ui-lib";
import { FC, ReactNode, useCallback, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Scrollbar from '../Scrollbar/Scrollbar';
import './Page.styles.scss';
import PlatformHeader from "./PlatformHeader";

interface IProps {
    title: string;
    children: ReactNode;
    isShownStickyFooter?: boolean;
    onScroll?: (scrollTop: number) => void;
}

const Page: FC<IProps> = (
    {
        children,
        title,
        isShownStickyFooter,
        onScroll,
    }
) => {
    const [scrollTop, setScrollTop] = useState(0);
    
    const handleScroll = useCallback((values: any) => {
        setScrollTop(values.scrollTop);
        onScroll?.(values.scrollTop);
    }, [onScroll]);
    
    return (
        <div className="Page">
            <Scrollbar 
                isShownStickyFooter={isShownStickyFooter}
                onScrollFrame={handleScroll}
            >
                <Helmet title={`Report Pro by Datassential${title === '' ? '' : ' | '}${title}`}/>
                <PlatformNavigation/>
                <PlatformHeader/>
                <div className="Page__wrapper" data-scroll-top={scrollTop}>{children}</div>
            </Scrollbar>
        </div>
    );
};

export default Page;
